import Vue from 'vue';
import overlord from '@/overlord';
import isEqual from 'lodash/isEqual';
import toNumber from 'lodash/toNumber';

const emptyRoom = () => ({
  id: null,
  users: [],
  address: null,
  connectionIds: [],
  ownedBy: null,
  ownedByUser: null,
  ownershipRequestedBy: null,
  ownershipRequestedByUser: null,
  createdAt: null,
});
export default {
  namespaced: true,
  state: {
    stack: [],
  },
  actions: {
    async JOIN_ROOM({ state, commit }, address) {
      console.debug('[ROOM] Joining room at', { address });
      const room = await overlord.service('rooms').create({ address });
      commit('UPDATE_ROOM', room);
      return room;
    },
    async UPDATE_ROOM({ state, commit }, room) {
      commit('UPDATE_ROOM', room);
    },
    async REQUEST_CURRENT_ROOM_OWNERSHIP({ commit, getters }) {
      if (!getters.currentRoom.id) {
        return false;
      }
      const room = await overlord.service('rooms').update(getters.currentRoom.id, { action: 'request-ownership' });
      commit('UPDATE_ROOM', room);
      return true;
    },

    async CANCEL_CURRENT_ROOM_REQUESTED_OWNERSHIP({ commit, getters }) {
      if (!getters.currentRoom.id) {
        return false;
      }
      const room = await overlord.service('rooms').update(getters.currentRoom.id, { action: 'cancel-current-request-ownership' });
      commit('UPDATE_ROOM', room);
      return true;
    },
    async ACCEPT_CURRENT_ROOM_REQUESTED_OWNERSHIP({ commit, getters }) {
      if (!getters.currentRoom.id
        || !getters.currentRoom.ownershipRequestedBy
        || !getters.ownedByMe) {
        return false;
      }
      const room = await overlord.service('rooms').update(getters.currentRoom.id, { action: 'accept-requested-ownership' });
      commit('UPDATE_ROOM', room);
      return true;
    },
    async LEAVE_ALL_ROOMS({ state }) {
      state.stack.forEach((room) => {
        overlord.service('rooms').remove(room.id);
      });
    },
    async LEAVE_CURRENT_ROOM({ commit, getters }) {
      if (!getters.currentRoom.id) {
        return;
      }
      console.debug('[ROOM] Leaving room at', { address: getters.currentRoom.address });
      await overlord.service('rooms').remove(getters.currentRoom.id);
      commit('LEAVE_CURRENT_ROOM');
    },
  },
  getters: {
    currentRoom: state => state.stack[state.stack.length - 1] || emptyRoom(),
    blockableAddressOwnedByMe: (state, getters, rootState) => (address) => {
      // Avoid blocking components on unknown addresses
      if (address === null) {
        return true;
      }
      // Block components while app is not connected
      if (!rootState.app.connectionId) {
        return false;
      }

      // Fix overlord stringified ids
      const normalizeAddress = (addr) => {
        if (!addr.id) {
          return addr;
        }
        return {
          ...addr,
          id: toNumber(addr.id),
        };
      };

      // Room with this address exists
      const room = state.stack.find(item => isEqual(normalizeAddress(item.address), normalizeAddress(address)));
      // Block components while room couldn't be found
      if (!room) {
        return false;
      }

      // Owned by me (room matching blockable component address)
      return room.ownedBy === rootState.app.connectionId;
    },
    ownedByMe: (state, getters, rootState) => {
      if (!rootState.app.connectionId) {
        return false;
      }

      // Room without owner
      if (!getters.currentRoom.ownedBy) {
        return true;
      }

      // Owned by me
      return getters.currentRoom.ownedBy === rootState.app.connectionId;
    },
  },
  mutations: {
    LEAVE_CURRENT_ROOM(state) {
      state.stack.pop();
    },
    UPDATE_ROOM(state, room) {
      const index = state.stack.findIndex(item => item.id === room.id);
      if (index === -1) {
        state.stack.push(room);
      } else {
        Vue.set(state.stack, index, room);
      }
    },
  },
};
